import type { ReplyRef } from "../api";

interface Props {
  reply: ReplyRef;
  /** Si fourni, devient cliquable et fait scroller au message original */
  onJump?: (id: string) => void;
  /** Variante "dans le composer" (avant envoi) — affiche un X pour annuler */
  onCancel?: () => void;
}

const KIND_PREFIX: Record<string, string> = {
  invoice: "📄 Facture — ",
  phone:   "📞 Téléphonique — ",
  voice:   "🎤 Vocal — ",
};

export default function QuotedMessage({ reply, onJump, onCancel }: Props) {
  const prefix = reply.kind ? KIND_PREFIX[reply.kind] || "" : "";
  const body = (reply.body || "").replace(/\s+/g, " ").trim();
  const excerpt = body.length > 110 ? body.slice(0, 110) + "…" : body;

  return (
    <div
      className={`quote ${onJump ? "tap" : ""}`}
      onClick={onJump ? () => onJump(reply.id) : undefined}
      role={onJump ? "button" : undefined}
    >
      <div className="quote-bar" />
      <div className="quote-body">
        <div className="quote-author">{reply.identifier || reply.user_name || "Utilisateur"}</div>
        <div className="quote-excerpt">{prefix}{excerpt || "(message)"}</div>
      </div>
      {onCancel && (
        <button className="quote-close" onClick={(e) => { e.stopPropagation(); onCancel(); }} aria-label="Annuler la citation">×</button>
      )}
    </div>
  );
}
